class PlatVariacio{
    constructor(
        public id_plat: number = 0,
        public id_variacio: number = 0,
        public id_alternativa: number = 0,
    ){
    }
}
export {PlatVariacio}